'use client'
import { ReactNode } from 'react';

 const Loading = (props: any):ReactNode =>{

  return (<p>loading...</p>);
}
export default Loading;
